<!--督办-->
<template>
  <div>
    <el-drawer @reload="$reloadHandle" title="电子工牌" size="40%"
               :before-close="handleClose"
               :visible.sync="visiable"
               direction="rtl" append-to-body
               custom-class="demo-drawer" ref="drawer" class="details2">

      <div class="demo-drawer__content">


        <template>
          <div>
            <div class="detail-wrap">
              <el-form ref="editForm" :model="formData">
             
	<!--返回-->
  <div class="top">
			<i></i>电子工牌
		</div>
		<!--电子工牌-->
		<!-- <div class="fwpj">
			<span>电子工牌</span>
			<div class="star">
				<span class="on"></span>
				<span class="on"></span>
				<span class="on"></span>
				<span class="on"></span>
				<span></span>
			</div>
		</div> -->
		<div class="form-box">
			<!--具体说说看-->
		          <!-- <i class="icon icon-news"></i> -->
                <!-- <img src="images/head.png" alt=""> -->
                <!-- <span class="glyphicon glyphicon-search" aria-hidden="true"></span> -->
              
          

            <div class="aui-landlady">
                <div class="logo">
					<div>  <img src="statics/images/tag.png" style="width: 40px;" alt=""></div>
                    <div class="logo-item">
                      

                        <img src="statics/images/tag2.png" alt="">
                    </div>

                </div>
                <div class="touBg">
                    <!-- <img src="./statics/images/topBg.png" alt="" class="touBg"> -->
                    <div class="gsName">上岗资格证</div>
                    <div class="aui-mine-user">
                        <el-image v-if="formData.pic"
      style="width: 100px; height: 100px"
      :src="formData.pic"
      :fit="fit"></el-image>
      <img v-else src="statics/images/user-logo-001.png" alt="">

                    </div>
                    <div class="aui-mine-name">
                        <div><span class="span1">姓名</span>:<span class="span2">{{formData.name}}</span></div>
						<div><span class="span1">编号</span>:<span class="span2">{{formData.code}}</span></div>
                        <div><span class="span1">岗位</span>:<span class="span2">服务工程师</span></div>
                        <div><span class="span1">有效期限</span>:<span class="span2">{{formData.time}}</span></div>


                    </div>
                </div>
				<div style="height: 150px;"></div>
                <!-- <div>
                    <div><img src="./statics/images/003.jpg" class="erweima" alt=""></div>
                    <div class="test2">扫码查看详情</div>
                    <div class="test">服务热线：400-123-456</div>
                    

                </div> -->
            </div>
            <div style="height:5rem"></div>
			<!--选择标签-->
	
		

		</div>


              </el-form>
            </div>
          </div>
        </template>
        <div class="demo-drawer__footer" style="position: absolute;
    bottom: 5px;
    right: 5px;">
          <!-- <el-button @click="cancelForm">取 消</el-button> -->
          <el-button type="primary" @click="cancelForm">
            确 定
          </el-button>
        </div>
      </div>
    </el-drawer>

  </div>
</template>
<script>
 import '../../../../../public/statics/css/style.css'; 

import api from "@/api/projectApi";
import DictSelect from "@/components/formItem/dictSelect.vue";
import CheckSubjectSearch from "@/components/formItem/checkSubjectSearch.vue";
import HandlePopSearch from "@/components/formItem/handlePopSearch.vue";

export default {
  name: 'supervisingDialog',
  components: {HandlePopSearch, CheckSubjectSearch, DictSelect},
  props: ['multi', 'rowData', 'visiable'],
  created() {
    this.$objCopy(this.rowData, this.formData)
    this.formData.remark = null
    console.log(this.formData,'252525');
  },
  data() {
    return {
      formData: {
        pic:'',
        name:'',
        code:'',
        job:'',
        time:''
      },
    }
  },
  watch: {

  },
  methods: {



    confirm() {
      this.handleClose()
    },
    cancelForm() {
      this.handleClose()
    },
    handleClose() {
      this.visiable = false
      this.$emit('update:visiable', this.visiable)
    }
  }
}
</script>
<style lang="scss" scoped>

.details2 {

  ::v-deep .el-drawer .el-drawer__body {
    padding: 0 16px;
    background-color: #fff;
    position: relative;
  }

  ::v-deep .el-drawer .el-drawer__header {
    background-color: #fff;
  }

  ::v-deep .el-drawer__container {
    position: relative;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    background: aliceblue;
    background-color: rgb(38 38 38 / 70%);
  }

  #containt .table-detail {
    border-collapse: collapse;
    font-size: 12px;
    border: 1px solid #ededed;
  }

  .btn {
    text-align: center;
  }

  //   3个标签
  .information {
    padding: 0px 10px;
    background-color: #E1F2FF;
    color: #268AEA;
    border-radius: 3px;
    margin: 0 5px;
    font-size: 15px;
  }

  //   每个分支
  .d-item {
    border: 1px solid #ededed;
    padding-bottom: 5px;

    .title b {
      display: inline-block;
      line-height: 20px;
      font-size: 13px;
      font-weight: 600;
      margin-right: 84px;
      vertical-align: middle;
      color: rgb(42, 100, 148);
      position: relative;
      z-index: 2;
      background: rgba(42, 100, 148, 0.16);
      margin-left: 0px;
      margin-bottom: 8px;
      padding-left: 12px;
      padding-right: 14px;
      border-radius: 0px 28px 28px 0px;
    }

    .table-detail tr {
      margin-bottom: 10px;
      display: block;

      th {
        font-weight: 400;
        text-align: right;
        width: 7vw !important;
        font-size: 12px;
        position: relative;
        padding: 0 5px 0 4px;
        color: rgba(86, 86, 86, 0.96);
      }

      td {
        font-weight: 400;
        // text-align: right;
        width: 10vw !important;
        font-size: 12px;
        position: relative;
        padding: 0 0px 0 4px;
        color: rgba(0, 0, 0,);
      }
    }
  }

  ::v-deep .el-image__preview {
    width: 60px !important;
    height: 60px !important;
  }

  .pic_main {
    display: flex;
    margin-left: 20px;
    margin-top: 10px;

    .pic_item {
      display: flex;
      margin-right: 40px;

      span {
        white-space: nowrap;
        line-height: 60px;
        font-size: 12px;
        color: rgba(86, 86, 86, 0.96);
        font-weight: 400;

      }
    }
  }

  // 本单费用位置
  .expense {
    position: absolute;
    right: 20%;
    margin-top: 5px;
    color: #00c4b3;
    font-size: 13px;
  }

  // 滚动条样式

  /* 滚动条 */
  ::-webkit-scrollbar {
    width: 5px;
    height: 12px;
  }

  /* 滚动槽 */
  ::-webkit-scrollbar-track {
    border-radius: 0px;
    // background: rgba(224, 7, 7, 0.05);
  }

  /* 滚动条滑块 */
  ::-webkit-scrollbar-thumb {
    border-radius: 00px;
    background: #cfcece;
  }

  // 步骤条 圆的位置
  ::v-deep .el-timeline-item__node--normal {
    left: 0px !important;
    width: 12px;
    height: 12px;
  }

  ::v-deep .el-step__title {
    font-size: 13px !important;
    line-height: 38px;
  }
}

::v-deep .el-form-item .el-form-item__label {
  font-size: 12px;
  font-weight: 400;
  width: 100px;
}
</style>
